/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_F1Inputs */

const en_mk_sol_konsultan_f1 = /** @type {(inputs: Mk_Sol_Konsultan_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 consultants, 2 analysts, 1 partner`)
};

const id_mk_sol_konsultan_f1 = /** @type {(inputs: Mk_Sol_Konsultan_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 konsultan, 2 analis, 1 partner`)
};

/**
* | output |
* | --- |
* | "10 consultants, 2 analysts, 1 partner" |
*
* @param {Mk_Sol_Konsultan_F1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_f1 = /** @type {((inputs?: Mk_Sol_Konsultan_F1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_F1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_f1(inputs)
	return en_mk_sol_konsultan_f1(inputs)
});